import { Button, Select } from 'antd';
import React, { useState } from 'react';
import { useAllDatasets } from '../../../lib/hooks';
import { DatasetVersion } from '../../../types/dataset';
import { ArrowDownOutlined } from '@ant-design/icons';
import { getLatestDatasetVersion } from '../../../lib/api/dataset-api';

type Props = {
  onCopy: (selectedDataset: DatasetVersion) => void;
};

export const DatasetCopy = ({ onCopy }: Props) => {
  const { datasets, loading } = useAllDatasets();
  const [searchForCopy, setSearchForCopy] = useState<string | null>(null);

  const doCopy = async () => {
    if (searchForCopy) {
      // Every select option has a value, but this is the name of the dataset (to make select searchable)
      // Find the correct id for the dataset with this name
      const datasetId = datasets.find(dataset => dataset.name === searchForCopy)?.id;

      if (datasetId) {
        const latestVersion = await getLatestDatasetVersion(datasetId);

        if (latestVersion) {
          onCopy(latestVersion);
          setSearchForCopy(null);
        }
      }
    }
  };

  return (
    <>
      <Select
        placeholder="Select dataset..."
        showSearch
        allowClear
        value={searchForCopy || undefined}
        style={{ width: '100%' }}
        onChange={value => {
          setSearchForCopy(value);
        }}
        loading={loading}>
        {datasets &&
          datasets.map(dataset => (
            <Select.Option key={dataset.id} value={dataset.name}>
              {dataset.name}
            </Select.Option>
          ))}
      </Select>
      <Button disabled={!searchForCopy} onClick={doCopy} type="primary">
        <ArrowDownOutlined /> Copy settings
      </Button>
    </>
  );
};
